import React from 'react';
import { Alert, AlertDescription, AlertTitle } from 'component/ui/alert.jsx';
import logger from '../utils/logger.js';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('Uncaught error:', error, { componentStack: errorInfo?.componentStack });
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      if (process.env.REACT_APP_NODE_ENV === 'development') {
        return (
          <div className="container mx-auto p-4">
            <Alert variant="destructive">
              <AlertTitle>Something went wrong!</AlertTitle>
              <AlertDescription>
                <div className="mt-2 font-mono text-xs">
                  <p className="font-bold">{this.state.error && this.state.error.toString()}</p>
                  <details open className="mt-2 whitespace-pre-wrap">
                    <summary className="cursor-pointer">Component Stack</summary>
                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                  </details>
                </div>
              </AlertDescription>
            </Alert>
          </div>
        );
      }
      // You can render any custom fallback UI
      return (
        <div className="flex h-screen items-center justify-center">
          <Alert variant="destructive" className="max-w-lg">
            <AlertTitle>Oops! Something went wrong.</AlertTitle>
            <AlertDescription>
              We encountered an unexpected error. Please try refreshing the page.
            </AlertDescription>
          </Alert>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
